import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {AutomatService} from '../services/automat.service';
import {SwalComponent} from '@sweetalert2/ngx-sweetalert2';
import {Router} from '@angular/router';
import {NgxSpinnerService} from 'ngx-spinner';
import {environment} from '../../environments/environment';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { AddAutomatComponent } from '../add-automat/add-automat.component';
import { EditAutomatComponent } from '../edit-automat/edit-automat.component';

declare var $: any;


@Component({
    selector: 'app-firm-automats',
    templateUrl: './firm-automats.component.html',
    styleUrls: ['./firm-automats.component.css']
})
export class FirmAutomatsComponent implements OnInit {
    @ViewChild('errorSwal') private errorSwal: SwalComponent;
    @ViewChild('successSwal') private successSwal: SwalComponent;
    @ViewChild('closeNoteModal') closeNoteModal: ElementRef;
    public firmId: string;
    onMouseOver: boolean;
    mouseOverAutomat: string;
    public firm: any;
    public searchText;
    public automats = [];
    public automatsFirstDeactive = [];
    public automatsSecondsActive = [];
    public lat: any;
    public lng: any;
    repeater: any;
    hoursDiff: any;
    daysDiff: any;
    minutesDiff: any;
    minuteDiff: any;
    ngbModalOptions: NgbModalOptions;
    public selectDesc: any;
    public selectedDevice = {name: '', mac: '', vpnIpAddress: ''};
    public selectedBeacon = {name: ''};
    public selectedModem = {mark: ''};
    public selectedSim = {serial: '', phoneNumber: ''};
    public selectedVPos = {name: ''};
    public infoDesc = {infoDescription: '', _id: ''};
    public ModelImagePath = '';

    constructor(
                private modalService: NgbModal,
                private automatService: AutomatService,
                private router: Router, private spinner: NgxSpinnerService) {
        this.repeater = window.setInterval(() => $('#refresh').click(), 60000 * 1);
        this.ModelImagePath = environment.AutomatImagePath;
    }

    ngOnInit() {
        this.spinner.show();
        this.firm = localStorage.getItem('firm');
        this.firmId = localStorage.getItem('firmId');
        this.getAutomatsByFirm(this.firmId);

    }

    getAutomatsByFirm(firmId: string) {
        this.automatService.getAutomatsByFirm(firmId).subscribe(res => {
            this.automats = [];
            this.automatsFirstDeactive = [];
            this.automatsSecondsActive = [];
            res.dataAutomat.forEach(data => {
                if (data.device) {
                    if (!this.compareDate(data.device.lastInformed)) {
                        this.automatsFirstDeactive.push(data);
                    } else {
                        this.automatsSecondsActive.push(data);
                    }
                }
            });
            this.automats = this.automatsFirstDeactive.concat(this.automatsSecondsActive);
            console.log(this.automats);
            this.spinner.hide();
        }, error => {
            if (error.message === 'Error: Access Denied') {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                this.router.navigate(['/login']);
                this.spinner.hide();
            } else {
                this.errorSwal.title = error.status;
                this.errorSwal.text = error.error;
                this.errorSwal.show();
                this.spinner.hide();
            }
        });

    }

    startMarquee(automatId: string) {
        this.mouseOverAutomat = automatId;
        this.onMouseOver = true;
    }

    stopMarquee(automatId: string) {
        this.mouseOverAutomat = automatId;
        this.onMouseOver = false;
    }

    compareDate(lastInformed: Date) {
        const date1 = new Date(lastInformed).getTime();
        const date2 = new Date().getTime();
        const time = date2 - date1;
        this.minutesDiff = time / (60 * 1000);
        this.minuteDiff = Math.round(time / (60 * 1000));
        this.hoursDiff = Math.round(time / (3600 * 1000));
        this.daysDiff = Math.round(time / (3600 * 1000 * 24));
        if (this.minutesDiff <= 4) {
            return true;
        } else {
            return false;
        }
    }

    openAddAutomatModal() {
        this.ngbModalOptions = {
            centered: true,
            size: 'lg',
            keyboard: true,
            backdrop: true
        };
        const modalRef = this.modalService.open(AddAutomatComponent,this.ngbModalOptions);
        modalRef.result.then(res => {
            console.log('this is ',res);
        }).catch(err => {
                console.log('this is ',err);
            }
        );
    }

    selected(id: string) {
        localStorage.setItem('which', 'firm');
        localStorage.setItem('selectAutomat', id);
        this.ngbModalOptions = {
            centered: true,
            size: 'lg',
            keyboard: true,
            backdrop: true
        };
        const modalRef = this.modalService.open(EditAutomatComponent,this.ngbModalOptions);
        modalRef.result.then(res => {
            console.log('this is ',res);
        }).catch(err => {
                console.log('this is ',err);
            }
        );
    }

    selectedInfo(automat) {
        this.selectedDevice = automat.device;
        this.selectedBeacon = automat.beacon;
        this.selectedModem = automat.modem;
        this.selectedSim = automat.sim;
        this.selectedVPos = automat.vPos;
        console.log(this.selectedDevice);
    }

    deleteAutomat(id: string) {
        this.spinner.show();
        this.automatService.deleteAutomat(id).subscribe(res => {
            console.log(res);
            this.getAutomatsByFirm(this.firmId);
            this.spinner.hide();
        }, error => {
            if (error.message === 'Error: Access Denied') {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                this.router.navigate(['/login']);
                this.spinner.hide();
                this.successSwal.show();
            } else {
                this.errorSwal.title = error.status;
                this.errorSwal.text = error.error;
                this.errorSwal.show();
                this.spinner.hide();
            }
        });
    }

    getLocations(coordinates: any) {
        this.lat = coordinates[0];
        this.lng = coordinates[1];
    }

    getInfoDescriptions(id: string) {
        this.spinner.show();
        this.selectDesc = id;
        console.log(this.selectDesc);
        this.automatService.getInfoDescription(id).subscribe(res => {
            console.log(res);
            this.infoDesc = res;
            this.spinner.hide();
        }, error => {
            if (error.message === 'Error: Access Denied') {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                this.router.navigate(['/login']);
                this.spinner.hide();
                this.successSwal.show();
            } else {
                this.errorSwal.title = error.status;
                this.errorSwal.text = error.error;
                this.errorSwal.show();
                this.spinner.hide();
            }
        });
    }

    UpdateDescription(infoDescription: string) {
        this.spinner.show();
       const data = { infoDescription : infoDescription };
        this.automatService.updateDescription(data, this.selectDesc).subscribe(res => {
            console.log(res);
            this.infoDesc = res;
            this.closeNoteModal.nativeElement.click();
            this.successSwal.show();
            this.spinner.hide();
        }, error => {
            if (error.message === 'Error: Access Denied') {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                this.router.navigate(['/login']);
                this.spinner.hide();
                this.successSwal.show();
            } else {
                this.errorSwal.title = error.status;
                this.errorSwal.text = error.error;
                this.errorSwal.show();
                this.spinner.hide();
            }
        });
    }
}



// WEBPACK FOOTER //
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/firm-automats/firm-automats.component.ts